<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2780_215359)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.5 4.5C2.91015 4.5 0 7.41015 0 11C0 14.5899 2.91015 17.5 6.5 17.5H15.5C19.0899 17.5 22 14.5899 22 11C22 7.41015 19.0898 4.5 15.5 4.5H6.5ZM15.8146 7.09277C13.6567 7.09277 11.9074 8.8421 11.9074 11C11.9074 13.1579 13.6567 14.9072 15.8146 14.9072C17.9725 14.9072 19.7219 13.1579 19.7219 11C19.7219 8.8421 17.9725 7.09277 15.8146 7.09277Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_2780_215359">
<rect width="22" height="22" fill="white"/>
</clipPath>
</defs>
</svg>
